export default __webpack_public_path__ + "static/media/header-md-2x.3ef04c0e.webp";